<form [formGroup]="group">
  <h1 mat-dialog-title>
    {{ opMode === opModes.Create ? ("add" | translate) : ("edit" | translate) }}
    {{ "period" | translate }}
  </h1>
  <div mat-dialog-content>
    <mat-form-field>
      <mat-label>{{ "name" | translate }}</mat-label>
      <input matInput formControlName="name" />
    </mat-form-field>

    <mat-form-field>
      <mat-label>{{ "period-from" | translate }}</mat-label>
      <input (click)="pickerFrom.open()" matInput formControlName="from" [matDatepicker]="pickerFrom" />
      <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
      <mat-datepicker startView="multi-year" (yearSelected)="periodFromSelected($event); pickerFrom.close()"
        #pickerFrom></mat-datepicker>
    </mat-form-field>

    <mat-form-field>
      <mat-label>{{ "period-to" | translate }}</mat-label>
      <input (click)="pickerTo.open()" matInput formControlName="to" [matDatepicker]="pickerTo" />
      <mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
      <mat-datepicker startView="multi-year" (yearSelected)="periodToSelected($event); pickerTo.close()" #pickerTo>
      </mat-datepicker>
    </mat-form-field>
  </div>
  <div mat-dialog-actions align="end">
    <button mat-raised-button color="primary" [mat-dialog-close]="true" (click)="onConfirm()" cdkFocusInitial>
      {{ "confirm" | translate }}
    </button>

    <button mat-raised-button [mat-dialog-close]="false">
      {{ "cancel" | translate }}
    </button>
  </div>
</form>
